import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import RecordsWithParams from "../../../model/RecordsWithParams";
import { DataQueryParamsInterface } from "../../../model/DataQueryParams";
import { SingleAvailabilityOfferMedium } from "../../../model/SingleAvailabilityOfferMedium";
import { OfferCreatorFilterParams } from "../../../model/filter-params/OfferCreatorFilterParams";
import ContentType from "../ContentType";
import { PatchBodyType } from "../PatchBodyType";
import { UpdatableFields } from "../../../action/updateManyAvailabilities";
import { NumberishId } from "../../../model/type";

export class Endpoint extends ApiEndpoint {
    public get = <T = PayloadGet|Blob>(offerId: string, params: DataQueryParamsInterface<OfferCreatorFilterParams>, acceptContentType?: ContentType, extendedVersion?: boolean): Promise<AxiosResponse<T>> => {
        const config = {
            extra: { dataQueryParams: params, cancelable: true },
        }

        if (acceptContentType) {
            config['headers'] = { 'accept': acceptContentType };
        }

        if (acceptContentType === ContentType.XLSX) {
            config['responseType'] = 'blob';
            if (extendedVersion) {
                config['params'] = {
                    extendedVersion: 1
                }
            }
        }

        return this.connection.get('/offers/' + offerId + '/availabilities', config);
    }

    public patch = (offerId: string, body: PatchBody): Promise<AxiosResponse<any>> => {
        return this.connection.patch('/offers/' + offerId + '/availabilities', body);
    }
}

export type PayloadGet = RecordsWithParams<SingleAvailabilityOfferMedium>;
type PatchBody = PatchBodyType<'UPDATE', {
    mediumIds: Array<NumberishId>,
    availabilityIds: Array<NumberishId>,
    fields: UpdatableFields
}>
